//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/電柱描画
//------------------------------------------------------------------------------
import Point from '@arcgis/core/geometry/Point';
import Graphic from '@arcgis/core/Graphic';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';

/**
 * 電柱一覧描画
 */
export function drawPoles(layer, template, poleList) {
  if (!layer) {
    return;
  }

  // 電柱一覧作成
  const graphics = poleList.map((pole) => poleGraphic(pole, template));

  // 全削除して追加
  layer.removeAll();
  layer.addMany(graphics);
}


// 電柱アイコン
const POLE_ICON = new PictureMarkerSymbol({
  url: '/icons/pole-blue.svg',
  width: '20px',
  height: '20px',
});

/**
 * 電柱グラフィック作成
 */
function poleGraphic(pole, template) {

  // 座標
  const point = new Point({
    latitude: pole.latitude,
    longitude: pole.longitude,
  });

  // 属性
  const attributes = {
    type: 'pole',
    pole: pole,
  };

  // グラフィック作成
  return new Graphic({
    symbol: POLE_ICON,
    geometry: point,
    attributes: attributes,
    popupTemplate: template,
  });
}
